import { JarvisResponse } from "../jarvis-service";
import { KeyValues } from "../keyvalues";
import { IBid, IProvider } from "../provider";

export class FallbackProvider implements IProvider {
  public name = 'fallback';
  protected iu = `/100151972/${window.location.hostname}`;
  protected config = {} as JarvisResponse;

  constructor(protected kv: KeyValues) {}

  public configure(config: JarvisResponse, iu: string) {
    this.config = config;
    this.iu = iu;
  }

  public async requestBids(params: { duration: number }) {
    const ppid = this.kv.getPPID();
    const url = encodeURIComponent(document.location.href);
    const provider = this;
    const bid = { cpm: 0, url: '' };

    const fallbackUrl1 = "https://pubads.g.doubleclick.net/gampad/ads?sz=640x480" +
      "&iu=" + this.iu +
      "&cust_params=" + this.kv.getUrlParam({ retryOnError: '2' }) +
      "&impl=s" +
      "&gdfp_req=1" +
      "&env=vp" +
      "&output=vast" +
      "&unviewed_position_start=1" +
      "&vad_type=linear" +
      "&url=" + url +
      "&description_url=" + url +
      "&correlator=" + parseInt(Math.random() * 1e15 + '');

    const fallbackUrl2 = 'https://pubads.g.doubleclick.net/gampad/ads?iu=' + this.iu +
      '&url=' + url +
      '&description_url=' + url +
      '&trt=2' +
      '&plcmt=1' +
      '&tfcd=0&npa=0&sz=1x1%7C640x480' +
      '&afvsz=200x200%2C250x250%2C300x250%2C336x280%2C450x50%2C468x60%2C480x90' +
      "&cust_params=" + this.kv.getUrlParam({ retryOnError: '3' }) +
      '&min_ad_duration=1000&max_ad_duration=31000' +
      (this.iu.includes(',') ? '&ipd=arkadium.com' : '') +
      (ppid ? '&ppid=' + ppid : '') +
      '&gdfp_req=1&unviewed_position_start=1&output=vast&env=vp&impl=s';

    bid.url = Math.random() > 0.5 ? fallbackUrl1 : fallbackUrl2;

    return [ { bid, provider } ];
  }

  public buildVideoUrl(bid: any, noIma: boolean) {
    const noImaUrl = 'https://optimized-by.rubiconproject.com/a/api/vast.xml?account_id=17214&site_id=161772&zone_id=775734&size_id=201&p_aso.video.protocols=2,5,3,6,7,8&p_aso.video.maxduration=30&p_aso.video.mimes="application/javascript","video/mp4"&p_aso.video.playbackmethod=3&p_aso.video.api=2';
    return Promise.resolve(noIma ? noImaUrl : bid.bid.url);
  }

  public cleanup() {}
}
